<ppb-start-container>
  <form [formGroup]="loginForm">
    <div>
      <div>
        <h3 class="login-title"
            i18n="@@login.password_reset_title"
        >Resetuj hasło</h3>
        <div class="login-field-cont">
          <div class="o-form-group">
            <pseic-form-field label="E-mail"
                              labelFor="email"
                              [resizeOnError]="false"
                              i18n-label="@@common.email">
              <input class="o-form-field"
                     placeholder="Twój adres e-mail"
                     autofocus
                     id="email"
                     type="text"
                     pseicAutofocus
                     formControlName="email"
                     i18n-placeholder="@@login.user_email">
            </pseic-form-field>
          </div>
        </div>
        <div class="confirm-message"
             *ngIf="step === 2"
             i18n="@@login.confirm_message">
          Na adres {{this.loginForm.getRawValue().email}} wysłano wiadomość z instrukcją resetu hasła.
          <br>Sprawdź skrzynkę odbiorczą.
          <br>Brak wiadomości oznacza, że Twoje konto nie zostało aktywowane w systemie lub zostało wyłączone.
        </div>
        <div *ngIf="step === 1"
             fxLayout="row"
             fxLayoutAlign="space-between stretch">
          <div>
            <button class="o-btn o-btn--secondary o-btn--small"
                    type="button"
                    [routerLink]="['/login']"
                    [state]="{email: this.providedEmail}"
                    i18n="@@common.cancel"
            >Anuluj</button>
          </div>
          <div>
            <pseic-async-button
              [isLoading$]="isLoading$"
              [type]="ButtonType.SUBMIT"
              (buttonClicked)="nextStep(2)"
              i18n="@@common.next"
            >Dalej
            </pseic-async-button>
          </div>
        </div>
        <div *ngIf="step === 2"
             fxLayout="row"
             fxLayoutAlign="end stretch">
          <div>
            <button class="o-btn o-btn--primary o-btn--small"
                    type="button"
                    routerLink="/"
                    i18n="@@common.go_to_home_page"
            >Powrót do strony głównej
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ppb-start-container>
